import React from 'react';
import { FiCode, FiServer, FiLayers } from 'react-icons/fi';
import { useInView } from '../../hooks/useInView';
import '../../App.css';

const services = [
  { icon: <FiCode />, title: "Custom Software", description: "Tailored solutions for your unique business needs" },
  { icon: <FiServer />, title: "Cloud Infrastructure", description: "Scalable and secure cloud architecture" },
  { icon: <FiLayers />, title: "SaaS Development", description: "Software-as-a-service platforms" }
];

function ServicesSection() {
  const { ref, isVisible } = useInView();

  return (
    <section id="services" className="services-section" ref={ref}>
      <div className="container">
        <div className={`section-header ${isVisible ? 'visible' : ''}`}>
          <span className="section-label">What We Offer</span>
          <h2 className="section-title">Core Services</h2>
        </div>
        <div className="services-grid">
          {services.map((service, index) => (
            <div
              key={index}
              className={`service-card ${isVisible ? 'visible' : ''}`}
              style={{ animationDelay: `${index * 100}ms` }}
            >
              <div className="service-icon">{service.icon}</div>
              <h3>{service.title}</h3>
              <p>{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default ServicesSection;
